import IRequest from "../../IRequest";

export interface ITiposDocumentos {
    reqTiposDocumentos: IRequest<TTipoDocReceber>,
    dataTiposDocumentos: TTipoDocReceber[]
  }

export type TTipoDocReceber = {
  id: string;
  nome: string;
  considera_bloqueio: 'N' | 'S';
  dias_carencia_bloqueio: number;
  tipo_limite_credito: "Consumo" | "Financiamento" | "Sacaria" | "Veterinário" | "Fertilizantes" | "Serviços" | "Geral";
  considera_limite: 'Considera Sempre' | 'Não Considera' | 'Considera apenas se o vencimento está no período do limite';
  sugestao_numero: number;
  considera_fechamento_cco: 'N' | 'S';
}

export const defValueTipoDocumento = {
  id: '',
  nome: '',
  considera_bloqueio: 'N',
  dias_carencia_bloqueio: 0,
  tipo_limite_credito: 'Geral',
  considera_limite: 'Considera Sempre',
  sugestao_numero: 0,
}